export default __webpack_public_path__ + "static/media/UserGuides_Icon.201f2b1b.png";